<template>
  <div v-if="personalReimInfo.applyId" ref="personalReim_content" class="personalReim-box">
    <div class="personalReim-headers" :class="'headers-background-'+personalReimInfo.applyStatus">
      <headers
        :headInfo="{headUrl: personalReimInfo.dingDingPhotoPath, dingdingUserId:personalReimInfo.currentApplyDingDingId, userName: personalReimInfo.currentApplyEmployeename, approver: personalReimInfo.nextApprover, approvalState: personalReimInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="personalReim_tab" class="personalReim-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="personalReim-info d_jump">
        <div class="personalReim-info-content">
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">项目名称</div>
            <router-link
              v-if="personalReimInfo.projectType=='Business'"
              class="personalReim-info-value bg-color"
              :to="{name:'projectInfo',query:{projectCode:personalReimInfo.projectCode}}"
            >{{personalReimInfo.projectname}}</router-link>
            <div v-else class="personalReim-info-value">{{personalReimInfo.projectname}}</div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">业务单元</div>
            <div class="personalReim-info-value">{{personalReimInfo.financialDeptname}}</div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">报销人</div>
            <div
              class="personalReim-info-value"
            >{{personalReimInfo.operatorEmname+'-'+personalReimInfo.operatorWholeDept}}</div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">报销公司</div>
            <div class="personalReim-info-value">{{personalReimInfo.companyname}}</div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">报销说明</div>
            <div
              class="personalReim-info-value"
              v-html="$options.filters.textareaToFormat(personalReimInfo.summary)"
            ></div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">实际用途</div>
            <div
              class="personalReim-info-value"
              v-html="$options.filters.textareaToFormat(personalReimInfo.actualReimSummary)"
            ></div>
          </div>
          <div class="personalReim-info-box">
            <div class="personalReim-info-label">附件</div>
            <div class="personalReim-info-value">
              <filebox message="暂无附件相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <!--报销明细信息开始-->
        <div>
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">费用明细</div>
              <div class="purchase-order-Total">
                报销总金额
                <span>{{personalReimInfo.paymentAmount|NumFormat}}元</span>
              </div>
              <div
                v-for="(detailItems,index) in personalReimInfo.personalReimItems"
                :key="index+200"
                class="ReimItem-content"
              >
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-label">支出项目</div>
                    <div class="ReimItem-vlue">{{detailItems.itemName}}</div>
                    <div class="ReimItem-label">报销金额</div>
                    <div
                      style="color: #333333;"
                      class="ReimItem-label"
                    >{{detailItems.reimAmount|NumFormat}}元</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">资金使用说明</div>
                    <div class="ReimItem-vlue">{{detailItems.useFundsExplain}}</div>
                  </div>
                </div>
                <div
                  v-if="detailItems.personalReimCarfares&&detailItems.personalReimCarfares.length>0"
                  class="personalReim-city-row"
                >
                  <div class="personalReim-city-title">交通费用</div>
                  <div
                    v-for="(ReimCarfaresItem,index) in detailItems.personalReimCarfares"
                    :key="index+100"
                  >
                    <div
                      class="ReimItem-time"
                    >出行时间： {{ReimCarfaresItem.incurredDate}} {{ReimCarfaresItem.startTime+"~"+ReimCarfaresItem.endTime}}</div>
                    <div class="ReimItem-address">
                      <div class="ReimItem-address-box">
                        <div class="ReimItem-address-label label-color">出发地点</div>
                        <div class="ReimItem-address-label label-color">到达地点</div>
                        <div class="amount label-color">金额</div>
                      </div>
                      <div class="ReimItem-address-box">
                        <div class="ReimItem-address-label">{{ReimCarfaresItem.startPlace}}</div>
                        <div class="ReimItem-address-label">{{ReimCarfaresItem.endPlace}}</div>
                        <div class="amount">{{ReimCarfaresItem.amount|NumFormat}}元</div>
                      </div>
                      <div class="personalReim-city-remark">
                        <div class="remark-label">事由:</div>
                        <div class="remark-value">{{ReimCarfaresItem.purpose}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="detailItems.personalReimOECosts&&detailItems.personalReimOECosts.length>0"
                  class="personalReim-city-row"
                >
                  <div class="personalReim-city-title">招待费用</div>
                  <div
                    v-for="(ReimOECostsItem,index) in detailItems.personalReimOECosts"
                    :key="index+300"
                  >
                    <div class="ReimItem-address">
                      <div class="ReimItem-address-box">
                        <div class="ReimItem-address-label label-color">日期</div>
                        <div class="ReimItem-address-label">{{ReimOECostsItem.incurredDate}}</div>
                        <div class="ReimItem-address-label label-color">金额</div>
                        <div class="ReimItem-address-label">{{ReimOECostsItem.amount|NumFormat}}元</div>
                      </div>
                      <div class="personalReim-city-remark remark-border-bottom">
                        <div class="remark-label">参与人员:</div>
                        <div class="remark-value">{{ReimOECostsItem.persons}}</div>
                      </div>
                      <div class="personalReim-city-remark">
                        <div class="remark-label">事由:</div>
                        <div class="remark-value">{{ReimOECostsItem.purpose}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--报销明细信息结束-->
        <!--采购信息开始-->
        <div v-if="personalReimInfo.purchaseInfo">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">采购申请信息</div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购项目</div>
                <div
                  class="purchase-info-content"
                >{{personalReimInfo.purchaseInfo.purchaseKindName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购总金额</div>
                <div
                  class="purchase-info-content"
                >{{personalReimInfo.purchaseInfo.totalPrice|NumFormat}}元（已付金额：{{personalReimInfo.approvePaymentAmounts|NumFormat}}元；未付金额：{{(personalReimInfo.purchaseInfo.totalPrice-personalReimInfo.purchaseInfo.approvePaymentAmounts)|NumFormat}}元）</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购分类</div>
                <div
                  class="purchase-info-content"
                >{{personalReimInfo.purchaseInfo.purchaseKindName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">采购需求人</div>
                <div
                  class="purchase-info-content"
                >{{personalReimInfo.purchaseInfo.requirementName+"-"+personalReimInfo.purchaseInfo.requirementDeptName}}</div>
              </div>
              <div class="purchase-info-box">
                <div class="purchase-info-label">相关文档</div>
                <div class="purchase-info-content">
                  <filebox message="暂无采购相关文档" :fileInfo="purchaseFileInfo"></filebox>
                </div>
              </div>
              <div
                v-for="(item,index) in personalReimInfo.purchaseInfo.detailsList"
                :key="index"
                class="purchase-orderinfo"
              >
                <div class="orderinfo-title-box">
                  <div class="orderinfo-title">供货商</div>
                  <div class="orderinfo-supplier">{{item.mainSupplierName}}</div>
                </div>
                <div class="orderinfo-title-box">
                  <div class="orderinfo-title">物品</div>
                  <div class="orderinfo-supplier">{{item.goodsName}}</div>
                </div>
                <div class="orderinfo-foot">
                  <div class="first-child">单价</div>
                  <div class="orderinfo-amount">{{item.mainSupplierPrice|NumFormat}}元</div>
                  <div class="third-child">合计金额</div>
                  <div class="orderinfo-amount">{{item.mainSupplierTotalPrice|NumFormat}}元</div>
                </div>
              </div>
              <div class="purchase-process">
                <lite-process :approvalList="personalReimInfo.purchaseInfo.approvalList"></lite-process>
              </div>
            </div>
          </div>
        </div>
        <!--采购信息结束-->
        <div class="divide-line"></div>
        <!--收款账户信息开始-->
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="purchase-order-label">收款账户信息</div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款单位</div>
              <div class="purchase-info-content">{{personalReimInfo.payeeEmname}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">收款账号</div>
              <div class="purchase-info-content">{{personalReimInfo.payeeAccount}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">开户行</div>
              <div class="purchase-info-content">{{personalReimInfo.payeeDepositBank}}</div>
            </div>
          </div>
        </div>
        <!--收款账户信息结束-->
        <div class="divide-line"></div>
        <!--发票信息开始-->
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="purchase-order-label">发票信息</div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">发票金额</div>
              <div class="purchase-info-content">{{personalReimInfo.invoiceAmount|NumFormat}}元</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">是否增值税发票</div>
              <div class="purchase-info-content">{{personalReimInfo.vATInvoiceFlag=='YES'?'是':'否'}}</div>
            </div>
            <div class="purchase-info-box">
              <div class="purchase-info-label">发票张数</div>
              <div class="purchase-info-content">{{personalReimInfo.invoiceCount}}</div>
            </div>
          </div>
        </div>
        <!--发票信息结束-->
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="personalReimInfo.approvalList"
          :applyEmployeeID="personalReimInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="personalReim-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:personalReimInfo.nextApproveStep}"
        v-if="personalReimInfo.nextApproverId&&personalReimInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&personalReimInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:personalReimInfo.nextApproverUserId,applyEmployeeName:personalReimInfo.currentApplyEmployeeName, applyTypeName:'个人费用报销申请'}"
        v-else-if="personalReimInfo.applyEmployeeID==userInfo.employeeID&&personalReimInfo.applyStatus=='SAVE'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>
<script>
import liteProcess from "@/components/Approval/ApprovalProcess/approvalProcess_Lite";
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
export default {
  data() {
    return {
      paramInfo: {},
      personalReimInfo: {},
      fileInfo: {},
      purchaseFileInfo: {}, //采购相关文档
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [
          { key: 0, value: "申请信息" },
          { key: 1, value: "审批信息" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getPersonalReimInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/FD/PersonalReim/GetPersonalReimApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.attachmentFilePath,
                filenames: res.data.data.attachmentFilename
              };
              if (res.data.data.purchaseInfo != null) {
                _this.purchaseFileInfo = {
                  filesrcs: res.data.data.purchaseInfo.quotationPath,
                  filenames: res.data.data.purchaseInfo.quotationFName
                };
              }
              if (res.data.data.invoiceFile.length > 0) {
                let invoiceFilePath = "";
                let invoiceFileName = "";
                res.data.data.invoiceFile.forEach((item, index, arr) => {
                  invoiceFilePath += item.invoiceFilePath + "|";
                  invoiceFileName += item.invoiceFileName + "|";
                });
              }
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    }
  },
  async mounted() {
    debugger;
    let _this = this;
    this.paramInfo = { ...this.$route.query };
    this.personalReimInfo = await this.getPersonalReimInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.personalReim_content.offsetTop - 1;
      _this.$refs.personalReim_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
  },
  components: {
    liteProcess,
    headers,
    tab,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>

<style lang="less" scoped>
.personalReim-box {
  .personalReim-headers {
    padding: 0 0.4rem;
  }

  .personalReim-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .personalReim-info {
      .personalReim-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .personalReim-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .personalReim-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .personalReim-info-value {
            margin-left: 0.133333rem;
            width: 80%;
            color: #333333;
          }
           .bg-color{
            color: #55b9fc!important;
          }
        }
      }
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .ReimItem-content {
        margin-top: 0.533333rem;
        .ReimItem-box {
          border-bottom: 1px solid #eee;
          .ReimItem {
            display: flex;
            border-left: 1px solid #eee;
            .ReimItem-label {
              width: 2rem;
              color: #999;
              border-top: 1px solid #eee;
            }
            .ReimItem-vlue {
              border-top: 1px solid #eee;
              flex: 1;
              color: #333333;
              padding-left: 0.13rem;
            }
            div {
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 1.066667rem;
              border-right: 1px solid #eee;
            }
          }
        }
        .personalReim-city-row {
          // margin-top: 0.533333rem;
          .personalReim-city-title {
            text-align: center;
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;

            height: 1.066667rem;
            line-height: 1.066667rem;
            font-weight: bold;
          }
          .ReimItem-time {
            height: 1.066667rem;
            line-height: 1.066667rem;
            padding-left: 0.3rem;
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;
            border-top: 1px solid #eee;
          }
          .ReimItem-address {
            border: 1px solid #eee;
            .ReimItem-address-box {
              width: 100%;
              display: flex;
              .label-color {
                color: #999;
              }
              .ReimItem-address-label {
                min-height: 1.066667rem;
                flex: 1;
                border-bottom: 1px solid #eee;
                border-right: 1px solid #eee;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .amount {
                width: 1.6rem;
                min-height: 1.066667rem;
                border-bottom: 1px solid #eee;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            .remark-border-bottom {
              border-bottom: 1px solid #eee;
            }
            .personalReim-city-remark {
              width: 100%;
              min-height: 1.333333rem;
              display: flex;
              .remark-label {
                width: 1.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .remark-value {
                flex: 1;
                display: flex;
                align-items: center;
              }
            }
          }
          .othen-cost {
            display: flex;
            width: 100%;
            height: 1.066667rem;
            line-height: 1.066667rem;
            text-align: center;
            border-bottom: 1px solid #eee;
            div {
              flex: 1;
              height: 100%;
              border-right: 1px solid #eee;
            }
          }
        }
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .purchase-info-box {
            margin-top: 0.533333rem;
            font-size: 0.373333rem;
            display: flex;
            .purchase-info-label {
              text-align: center;
              flex: 1;
              color: #999;
            }
            .purchase-info-content {
              margin-left: 0.133333rem;
              width: 76%;
              color: #333333;
            }
          }
          .purchase-process {
            margin-top: 0.4rem;
          }
        }
      }
      .purchase-paymentHistory {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order-label {
          height: 1.253333rem;
          line-height: 1.253333rem;
          font-size: 0.453333rem;
          color: #333333;
          font-weight: bold;
          border-bottom: 1px solid #eee;
        }
      }
      .purchase-orderinfo {
        margin-top: 0.533333rem;
        width: 100%;
        font-size: 0.373333rem;
        border: 1px solid #eee;
        .orderinfo-title-box {
          width: 100%;
          border-bottom: 1px solid #eee;
          display: flex;
          text-align: center;
          .orderinfo-title {
            width: 1.333333rem;
            min-height: 1.08rem;
            color: #999;
            border-right: 1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .orderinfo-supplier {
            flex: 1;
            color: #333333;
            padding: 0.13rem;
          }
        }
        .borderbottom {
          border-bottom: 1px solid #eee;
          .borderleft {
            min-width: 1.066667rem;
            border-left: 1px solid #eee;
          }
        }
        .orderinfo-foot {
          width: 100%;
          display: flex;
          color: #999;
          .first-child {
            width: 1.333333rem;
          }
          .third-child {
            width: 2rem;
            border-left: 1px solid #eee;
          }
          div {
            height: 1.08rem;
            line-height: 1.08rem;
            text-align: center;
          }
          .orderinfo-amount {
            flex: 1;
            color: #333;
            border-left: 1px solid #eee;
          }
        }
        .handle {
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: right;
          padding-right: 0.4rem;
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .personalReim-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/FD/PersonalReim/index.vue